import React from 'react';
import { ButtonLink, Flex, Text } from '@applyboard/crystal-ui';
import { GradeConversionTable } from '../components/GradeConversionTable';
import { GradeConversionPagination } from '../components/GradeConversionPagination';
import { Sort } from '../components/filters';

export function MobileLayout() {
  return (
    <Flex pt={4} gap={4} direction="column">
      <Flex justify="between" align="center">
        <Flex direction="column">
          <Text variant="titleM">Grade Conversion</Text>
          <Text contrast="low">
            Manage the grade conversion rules from foreign grading systems to your institution&apos;s scale.
          </Text>
        </Flex>
        <ButtonLink href="/conversion-rules/grade-conversions/new" intent="primary">
          Create Conversion
        </ButtonLink>
      </Flex>
      <Flex gap={2} justify="end">
        <Filter as={<Sort />} width="auto" />
      </Flex>
      <GradeConversionTable />
      <GradeConversionPagination />
    </Flex>
  );
}

function Filter(props: { as: React.ReactNode; width: string }) {
  return <div style={{ width: props.width }}>{props.as}</div>;
}
